import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';
import { getLocaleData } from './localeSelectors';

export const getOneCmsBaseUrl = createConfigSelector('oneCmsBaseUrl');
export const getOneCmsInternetBaseUrl = createConfigSelector(
  'oneCMSInternetBaseUrl'
);

export const getOneCmsLoungeFinderBaseUrl = createSelector(
  getOneCmsBaseUrl,
  (oneCmsBaseUrl) => `${oneCmsBaseUrl}/content/dam/one-amex/lounge-finder`
);

export const getOneCmsLoungeFinderImagesBaseUrl = createSelector(
  getOneCmsInternetBaseUrl,
  (oneCmsInternetBaseUrl) =>
    `${oneCmsInternetBaseUrl}/content/dam/one-amex/lounge-finder/images/`
);

export const getOneCmsLocaleProductUrl = (product) =>
  createSelector(
    getOneCmsLoungeFinderBaseUrl,
    getLocaleData,
    (oneCmsLoungeFinderBaseUrl, { locale }) =>
      `${oneCmsLoungeFinderBaseUrl}/${locale.toLowerCase()}/${product || 'the-platinum-card'}.json`
  );

export const getOneCmsLocaleAirportsUrl = (locale) =>
  createSelector(
    getOneCmsLoungeFinderBaseUrl,
    (oneCmsLoungeFinderBaseUrl) =>
      `${oneCmsLoungeFinderBaseUrl}/${locale?.toLowerCase()}/airports.json`
  );

export const getOneCmsLocaleLoungesUrl = createSelector(
  getOneCmsLoungeFinderBaseUrl,
  getLocaleData,
  (oneCmsLoungeFinderBaseUrl, { locale }) =>
    `${oneCmsLoungeFinderBaseUrl}/${locale.toLowerCase()}/lounges.json`
);

export const getOneCmsLocaleCommonUrl = createSelector(
  getOneCmsLoungeFinderBaseUrl,
  getLocaleData,
  (oneCmsLoungeFinderBaseUrl, { locale }) =>
    `${oneCmsLoungeFinderBaseUrl}/${locale.toLowerCase()}/common.json`
);
